import axios from "axios";

// Production HolyLand Award backend (same as mobile app).
// All web users share the same database with iOS/Android users.
// Override via REACT_APP_API_URL env var when self-hosting.
export const API =
  process.env.REACT_APP_API_URL || "https://api.holylandaward.com/api";

export const api = axios.create({ baseURL: API, timeout: 20000 });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("hla_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("hla_token");
      localStorage.removeItem("hla_user");
    }
    return Promise.reject(err);
  },
);

// Auth endpoints (matching mobile app)
export const auth = {
  login: (data) => api.post("/auth/login", data).then((r) => r.data),
  register: (data) => api.post("/auth/register", data).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
  logout: () => api.post("/auth/logout").then((r) => r.data),
  googleSession: (data) =>
    api.post("/auth/google/session", data).then((r) => r.data),
};

// Geography
export const geo = {
  districts: () => api.get("/districts").then((r) => r.data),
  squares: (params) => api.get("/squares", { params }).then((r) => r.data),
  adminBoundaries: () => api.get("/admin-boundaries").then((r) => r.data),
  whereAmI: (params) =>
    api.get("/where-am-i", { params }).then((r) => r.data),
};

export const squaresApi = {
  list: (params) => api.get("/squares", { params }).then((r) => r.data),
};

// Activations (check-ins / QSOs)
export const activations = {
  list: (params) => api.get("/activations", { params }).then((r) => r.data),
  bulkSync: (items) =>
    api.post("/activations/bulk-sync", { items }).then((r) => r.data),
};

// Spots (DX cluster)
export const spots = {
  list: () => api.get("/spots").then((r) => r.data),
  active: () => api.get("/spots/active").then((r) => r.data),
};

// Chat
export const chat = {
  list: () => api.get("/chat/messages").then((r) => r.data),
  send: (text) => api.post("/chat/messages", { text }).then((r) => r.data),
};

// Legal
export const legal = {
  privacy: () => api.get("/legal/privacy").then((r) => r.data),
  terms: () => api.get("/legal/terms").then((r) => r.data),
};
